module.exports = __webpack_public_path__ + "static/media/clinician-blood-thinner-types-preview@2x.0e261307.png";